// extracted by mini-css-extract-plugin
module.exports = {"selector":"collection-picker-component_selector__i0TxJ"};